import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { SchedulingComponent } from './scheduling.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'ma-form-field-scheduling',
    template: ` <ma-scheduling [formControl]="formControl"></ma-scheduling> `,
    imports: [SchedulingComponent, FormsModule, ReactiveFormsModule]
})
export class SchedulingFormFieldComponent extends FieldType {}
